import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import toast from 'react-hot-toast';

export default function SignUpPage() {
  const [form, setForm] = useState({
    email: '', password: '', name: '', phone: '',
    role: 'guest', business_number: '', business_name: '',
  });
  const { signUp, loading } = useAuthStore();
  const navigate = useNavigate();
  const isBusiness = form.role === 'host';

  const update = (key: string, value: string) => setForm(f => ({ ...f, [key]: value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.password.length < 8) {
      toast.error('비밀번호는 8자 이상이어야 합니다');
      return;
    }
    try {
      await signUp(form);
      toast.success('가입이 완료되었습니다');
      navigate('/');
    } catch (err: any) {
      toast.error(err.message || '가입에 실패했습니다');
    }
  };

  return (
    <div className="max-w-lg mx-auto px-4 py-12">
      <div className="card p-8">
        <h1 className="text-2xl font-bold text-center mb-2">회원가입</h1>
        <p className="text-center text-gray-500 text-sm mb-8">CarP2P에 오신 것을 환영합니다</p>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Role Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">가입 유형</label>
            <div className="grid grid-cols-2 gap-3">
              {[
                { value: 'guest', label: '제작사 (게스트)', desc: '차량을 빌립니다' },
                { value: 'host', label: '차주 (호스트)', desc: '차량을 등록합니다' },
              ].map(opt => (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => update('role', opt.value)}
                  className={`p-4 rounded-xl border-2 text-left transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500 ${
                    form.role === opt.value
                      ? 'border-brand-500 bg-brand-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <p className="font-medium text-sm">{opt.label}</p>
                  <p className="text-xs text-gray-500 mt-1">{opt.desc}</p>
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">이메일</label>
            <input type="email" className="input-field" value={form.email} onChange={e => update('email', e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">비밀번호 (8자 이상)</label>
            <input type="password" className="input-field" value={form.password} onChange={e => update('password', e.target.value)} required minLength={8} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">이름</label>
              <input type="text" className="input-field" value={form.name} onChange={e => update('name', e.target.value)} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">연락처</label>
              <input type="tel" className="input-field" value={form.phone} onChange={e => update('phone', e.target.value)} required />
            </div>
          </div>

          {isBusiness && (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">사업자등록번호</label>
                <input type="text" className="input-field" value={form.business_number} onChange={e => update('business_number', e.target.value)} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">상호명</label>
                <input type="text" className="input-field" value={form.business_name} onChange={e => update('business_name', e.target.value)} />
              </div>
            </>
          )}

          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? '처리 중...' : '가입하기'}
          </button>
        </form>

        <p className="text-center text-sm text-gray-500 mt-6">
          이미 계정이 있으신가요? <Link to="/signin" className="text-brand-600 hover:underline transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-brand-500 rounded">로그인</Link>
        </p>
      </div>
    </div>
  );
}
